import { useNavigate } from 'react-router-dom'
import HelpDeskAddBene from './HelpDeskAddBene'
import ChhiForm from './ChhiForm'

function HelpDeskBene ({
  setChiReqRecord,
  setSystemType,
  chiReqRecord,
  systemType,
  eligibilityId,
  setEligibilityId
}) {
  const navigate = useNavigate()
  return (
    <div className='superGit_container'>
      <div className='benefeciary-create'>
        <ChhiForm
          setChiReqRecord={setChiReqRecord}
          setSystemType={setSystemType}
          eligibilityId={eligibilityId}
          setEligibilityId={setEligibilityId}
        />
        <HelpDeskAddBene
          item={null}
          chiReqRecord={chiReqRecord}
          setChiReqRecord={setChiReqRecord}
          systemType={systemType}
          eligibilityId={eligibilityId}
          setEligibilityId={setEligibilityId}
        />
      </div>
    </div>
  )
}

export default HelpDeskBene
